export const ui = {
  page: 'min-h-screen bg-surface',
  pageBody: 'px-6 py-6 lg:px-8',
  header: 'border-b border-border bg-white px-6 py-5 lg:px-8',
  headerTitle: 'text-2xl font-semibold tracking-tight text-text',
  headerDescription: 'mt-1 text-sm text-muted',
  panel: 'overflow-hidden rounded-2xl border border-border bg-card shadow-card',
  panelHeader: 'border-b border-border px-5 py-4',
  panelBody: 'p-5',
  input:
    'w-full rounded-xl border border-border bg-white px-3 py-2.5 text-sm text-text outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/20',
  select:
    'w-full rounded-xl border border-border bg-white px-3 py-2.5 text-sm text-text outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/20 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-muted',
  btn:
    'inline-flex items-center justify-center gap-2 rounded-xl border border-border bg-white px-4 py-2.5 text-sm font-medium text-text transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60',
  btnPrimary:
    'inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60',
  btnDanger:
    'inline-flex items-center justify-center gap-2 rounded-xl border border-red-200 bg-red-50 px-4 py-2.5 text-sm font-medium text-danger transition hover:bg-red-100',
  btnGhost:
    'inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium text-muted transition hover:bg-slate-50 hover:text-text',
  tableWrap: 'overflow-x-auto',
  table: 'min-w-full text-sm',
  tableHead:
    'sticky top-0 z-10 bg-slate-50/95 text-left text-xs font-semibold uppercase tracking-wide text-muted backdrop-blur',
  tableHeadCell: 'px-5 py-3',
  tableRow: 'border-b border-border transition hover:bg-primary-light/40',
  tableRowZebra: 'bg-slate-50/60',
  tableCell: 'px-5 py-4 align-middle text-text',
  emptyCell: 'px-5 py-10 text-center text-muted',
  badge:
    'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset',
  badgeSuccess: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  badgeWarning: 'bg-amber-50 text-amber-700 ring-amber-200',
  badgeDanger: 'bg-red-50 text-red-700 ring-red-200',
  badgeNeutral: 'bg-slate-100 text-slate-600 ring-slate-200',
  metricCard: 'rounded-2xl border border-border bg-card p-5 shadow-card',
  filtersGrid: 'grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3',
  filtersActions: 'mt-4 flex flex-wrap gap-3',
  pagination: 'flex flex-col gap-3 border-t border-border px-5 py-4 sm:flex-row sm:items-center sm:justify-between',
  modalOverlay: 'fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4 backdrop-blur-sm',
  modal: 'max-h-[90vh] w-full max-w-4xl overflow-hidden rounded-2xl border border-border bg-white shadow-2xl',
  modalHeader: 'flex items-center justify-between border-b border-border px-6 py-4',
  modalBody: 'max-h-[calc(90vh-140px)] overflow-y-auto px-6 py-5',
  modalFooter: 'flex justify-end gap-3 border-t border-border px-6 py-4',
  label: 'mb-1.5 block text-sm font-medium text-text',
  spinner: 'h-5 w-5 animate-spin rounded-full border-2 border-primary border-t-transparent',
};

export function getInitials(name) {
  if (!name) return 'U';
  return String(name)
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
}
